import {
  REWARD_POOL_TICKET_CURRENCY,
  RewardPoolTicketCurrencyType,
} from '@shared/api/types/rewardPools';
import { concatCurrencyToAmount } from '@shared/helpers/formatters/concatCurrencyToAmount';

import { formatReward } from '@ui/uikit/utils';

import { PriceDetailItem } from './PriceDetailItem';

type Props = {
  currencyType: RewardPoolTicketCurrencyType;
  price: number;
  ticketsAmount: number;
};

export const PriceDetails = ({ currencyType, ticketsAmount }: Props) => {
  const { price, currency } = currencyType;

  if (currency === REWARD_POOL_TICKET_CURRENCY.FREE) {
    return (
      <PriceDetailItem
        description="You will use"
        value={`${ticketsAmount * price} Raffle Credit`}
      />
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <PriceDetailItem
        description="Ticket price"
        value={`${concatCurrencyToAmount(formatReward(price), currency, {
          stableToDollar: false,
        })}`}
      />
      <PriceDetailItem
        description="Total"
        value={concatCurrencyToAmount(formatReward(ticketsAmount * price), currency, {
          stableToDollar: false,
        })}
      />
    </div>
  );
};
